import React from "react";
import ProAgentsImg from "@/img/cyt_agents.png";
import AccountCreationForm from "./account-creation-form";
import ActivitySelection from "./activity-selection";
import SelectPlan from "./select-plan";
import CircleSteps from "@/components/navigation/CircleSteps";
import { useAtom } from "jotai";
import { atomWithStorage } from "jotai/utils";
import { useSession } from "@/_actions/authActions";
import { Button } from "@/components/ui/button";

const currentStepAtom = atomWithStorage("pro_signup_current_step", 0);
const selectedPlanAtom = atomWithStorage("pro_signup_selected_plan", null);

export default function Index() {
  const { data: session, isLoading } = useSession();
  const [currentStep, setCurrentStep] = useAtom(currentStepAtom);
  const [selectedPlan, setSelectedPlan] = useAtom(selectedPlanAtom);
  const urlParams = new URLSearchParams(window.location.search);
  const plan = urlParams.get("plan");
  if (plan) {
    setSelectedPlan(plan);
  }

  React.useEffect(() => {
    if (!session && !isLoading) {
      setCurrentStep(0);
      return;
    }
  }, [session, setCurrentStep, isLoading]);

  const steps = [
    {
      id: "account",
      label: "Cuenta",
      component: <AccountCreationForm callBack={() => setCurrentStep(1)} />,
    },
    {
      id: "activity",
      label: "Actividad",
      component: <ActivitySelection callBack={() => setCurrentStep(2)} />,
    },
    {
      id: "plan",
      label: "Plan",
      component: (
        <SelectPlan
          callBack={() => setCurrentStep(3)}
          selectedPlanId={selectedPlan}
        />
      ),
    },
  ];
  return (
    <div className="min-h-screen max-w-screen-2xl m-auto items-center justify-center space-y-5">
      <div className="relative flex items-center justify-center mb-6 mt-12 max-w-screen-md mx-auto">
        {currentStep > 0 && (
          <Button
            variant="link"
            className="absolute left-0 text-lg cursor-pointer"
            onClick={() => {
              setCurrentStep(currentStep - 1);
            }}
          >
            &larr; Volver
          </Button>
        )}

        <img className="h-16 w-auto" src={ProAgentsImg} alt="Cyt Logo" />
      </div>

      <div className="text-2xl font-bold text-center">
        {
          {
            0: "Configura tu cuenta PRO en unos minutos",
            1: "Describe tu actividad",
            2: "Elige tu plan",
          }[currentStep]
        }
      </div>
      <div className="max-w-screen-md mx-auto space-y-5">
        <CircleSteps
          orientation="horizontal"
          steps={steps.map((step, index) => ({
            name: step.label,
            description: "",
            status:
              index < currentStep
                ? "complete"
                : index === currentStep
                ? "current"
                : "upcoming",
            id: step.id,
            href: "#",
          }))}
        />
      </div>
      {steps[currentStep].component}
    </div>
  );
}
